module.exports = __webpack_public_path__ + "img/capa-hover-educacao.63e16fef.png";